import React from 'react';

import Saves from './Saves';
import Layout from '../../components/Layout';

async function action() {
  return {
    component: (
      <Layout>
        <Saves />
      </Layout>
    ),
  };
}

export default action;
